import { useState } from 'react';
import BeforeAfterSlider from './BeforeAfterSlider';

interface BAItem {
  id: number;
  title: string;
  location: string;
  size: string;
  date: string;
  process: string;
  description: string;
  beforeImg: string;
  afterImg: string;
  tags: string[];
}

const PROCESS_TABS = ['전체', '철거/구조', '욕실', '주방', '거실/방', '전기/조명', '도장/도배'];

const BA_DATA: BAItem[] = [
  {
    id: 1,
    title: '역삼동 래미안 거실 전체 리모델링',
    location: '강남구 역삼동',
    size: '34평',
    date: '2024.11',
    process: '거실/방',
    description: '낡은 몰딩과 어두운 벽지를 걷어내고 밝은 화이트 톤 + 오크 강마루로 완전히 탈바꿈. 간접조명 설치로 공간감이 2배 넓어졌습니다.',
    beforeImg: 'https://public.readdy.ai/ai/img_res/c648f8efb248d2e1270e81146a2fe2bc.jpg',
    afterImg: 'https://readdy.ai/api/search-image?query=modern%20renovated%20Korean%20apartment%20living%20room%20after%20renovation%20bright%20white%20walls%20oak%20hardwood%20floor%20minimalist%20furniture%20warm%20indirect%20lighting%20spacious%20clean%20elegant&width=800&height=600&seq=ba-after-01&orientation=landscape',
    tags: ['강마루', '간접조명', '도배'],
  },
  {
    id: 2,
    title: '대치동 은마 욕실 완전 교체',
    location: '강남구 대치동',
    size: '42평',
    date: '2024.09',
    process: '욕실',
    description: '30년 된 구형 욕실을 포세린 타일 + 반매립 세면대 + 빌트인 수납장으로 호텔급 욕실로 변신. 방수 전면 재시공으로 누수 걱정 없이.',
    beforeImg: 'https://readdy.ai/api/search-image?query=old%20outdated%20Korean%20bathroom%20before%20renovation%20worn%20tiles%20cracked%20grout%20rusty%20fixtures%20dim%20lighting%20aged%20bathroom%20realistic%20interior%20photography&width=800&height=600&seq=ba-before-02&orientation=landscape',
    afterImg: 'https://readdy.ai/api/search-image?query=luxury%20renovated%20Korean%20bathroom%20after%20renovation%20large%20format%20porcelain%20tiles%20semi-recessed%20sink%20built-in%20storage%20hotel%20style%20modern%20elegant%20bright%20clean&width=800&height=600&seq=ba-after-02&orientation=landscape',
    tags: ['포세린타일', '방수', '세면대'],
  },
  {
    id: 3,
    title: '압구정 빌라 주방 풀리모델링',
    location: '강남구 압구정동',
    size: '28평',
    date: '2024.06',
    process: '주방',
    description: '폐쇄형 주방을 오픈형으로 구조 변경. 세라믹 상판 + 헤링본 타일 백스플래시 + 빌트인 가전으로 요리가 즐거워지는 주방 완성.',
    beforeImg: 'https://readdy.ai/api/search-image?query=old%20closed%20Korean%20kitchen%20before%20renovation%20dark%20cabinets%20worn%20countertop%20outdated%20appliances%20cramped%20space%20dim%20lighting%20aged%20realistic%20interior%20photography&width=800&height=600&seq=ba-before-03&orientation=landscape',
    afterImg: 'https://readdy.ai/api/search-image?query=modern%20open%20plan%20Korean%20kitchen%20after%20renovation%20white%20cabinets%20ceramic%20countertop%20herringbone%20tile%20backsplash%20built-in%20appliances%20bright%20spacious%20elegant%20contemporary&width=800&height=600&seq=ba-after-03&orientation=landscape',
    tags: ['오픈형주방', '세라믹상판', '헤링본타일'],
  },
  {
    id: 4,
    title: '삼성동 오피스텔 철거 후 구조 변경',
    location: '강남구 삼성동',
    size: '18평',
    date: '2024.07',
    process: '철거/구조',
    description: '기존 벽체 철거 후 공간 재배치. 좁은 원룸을 1.5룸 구조로 변경하여 침실 프라이버시 확보. 철거 후 배관 전면 교체로 완벽한 기초 공사.',
    beforeImg: 'https://readdy.ai/api/search-image?query=Korean%20officetel%20studio%20apartment%20before%20demolition%20renovation%20old%20walls%20exposed%20concrete%20structural%20work%20construction%20site%20realistic%20interior%20photography&width=800&height=600&seq=ba-before-04&orientation=landscape',
    afterImg: 'https://readdy.ai/api/search-image?query=modern%20renovated%20Korean%20studio%20officetel%20after%20renovation%20smart%20layout%20bedroom%20partition%20living%20area%20clean%20minimalist%20design%20warm%20tones%20functional%20compact%20space&width=800&height=600&seq=ba-after-04&orientation=landscape',
    tags: ['구조변경', '철거', '배관교체'],
  },
  {
    id: 5,
    title: '도곡동 타워팰리스 안방 리모델링',
    location: '강남구 도곡동',
    size: '55평',
    date: '2024.04',
    process: '거실/방',
    description: '안방 드레스룸 + 욕실 연계 리모델링. 워크인 클로젯 맞춤 제작, 대리석 패턴 타일 욕실, 간접조명 헤드보드로 호텔 스위트룸 분위기.',
    beforeImg: 'https://readdy.ai/api/search-image?query=old%20Korean%20master%20bedroom%20before%20renovation%20dated%20wallpaper%20worn%20carpet%20outdated%20furniture%20dim%20lighting%20aged%20residential%20interior%20realistic%20photography&width=800&height=600&seq=ba-before-05&orientation=landscape',
    afterImg: 'https://readdy.ai/api/search-image?query=luxury%20Korean%20master%20bedroom%20after%20renovation%20walk-in%20closet%20indirect%20lighting%20headboard%20marble%20accent%20wall%20premium%20bedding%20hotel%20suite%20elegant%20sophisticated&width=800&height=600&seq=ba-after-05&orientation=landscape',
    tags: ['드레스룸', '간접조명', '대리석'],
  },
  {
    id: 6,
    title: '개포동 래미안 전기/조명 전면 교체',
    location: '강남구 개포동',
    size: '32평',
    date: '2024.02',
    process: '전기/조명',
    description: '20년 된 전기 배선 전면 교체 + 스마트홈 시스템 도입. 매입형 LED 다운라이트 + 간접조명 + 스마트 스위치로 분위기 있는 조명 연출.',
    beforeImg: 'https://readdy.ai/api/search-image?query=old%20Korean%20apartment%20ceiling%20before%20renovation%20outdated%20fluorescent%20lighting%20old%20electrical%20fixtures%20yellowed%20ceiling%20aged%20interior%20realistic%20photography&width=800&height=600&seq=ba-before-06&orientation=landscape',
    afterImg: 'https://readdy.ai/api/search-image?query=modern%20Korean%20apartment%20ceiling%20after%20renovation%20recessed%20LED%20downlights%20indirect%20cove%20lighting%20smart%20switches%20warm%20ambiance%20elegant%20contemporary%20interior&width=800&height=600&seq=ba-after-06&orientation=landscape',
    tags: ['LED조명', '스마트홈', '전기배선'],
  },
  {
    id: 7,
    title: '서초동 아크로리버파크 도장/도배',
    location: '서초구 서초동',
    size: '49평',
    date: '2023.12',
    process: '도장/도배',
    description: '전 공간 친환경 저VOC 페인트 + 실크 벽지 교체. 포인트 벽면에 패턴 벽지 적용으로 공간마다 다른 개성 연출. 아이 방은 항균 벽지 사용.',
    beforeImg: 'https://readdy.ai/api/search-image?query=old%20Korean%20apartment%20walls%20before%20renovation%20yellowed%20wallpaper%20peeling%20paint%20stained%20walls%20aged%20interior%20realistic%20photography%20before%20renovation&width=800&height=600&seq=ba-before-07&orientation=landscape',
    afterImg: 'https://readdy.ai/api/search-image?query=freshly%20renovated%20Korean%20apartment%20walls%20after%20renovation%20clean%20white%20silk%20wallpaper%20accent%20pattern%20wall%20elegant%20paint%20finish%20bright%20fresh%20interior%20contemporary&width=800&height=600&seq=ba-after-07&orientation=landscape',
    tags: ['친환경페인트', '실크벽지', '포인트벽'],
  },
  {
    id: 8,
    title: '청담동 빌라 욕실 2개 동시 시공',
    location: '강남구 청담동',
    size: '35평',
    date: '2023.10',
    process: '욕실',
    description: '안방 욕실 + 공용 욕실 동시 리모델링. 안방은 블랙 포인트 타일 + 레인샤워, 공용은 화이트 클린 컨셉으로 각각 다른 분위기 연출.',
    beforeImg: 'https://readdy.ai/api/search-image?query=old%20Korean%20villa%20bathroom%20before%20renovation%20worn%20tiles%20cracked%20grout%20outdated%20fixtures%20mold%20stains%20dim%20lighting%20aged%20bathroom%20realistic%20photography&width=800&height=600&seq=ba-before-08&orientation=landscape',
    afterImg: 'https://readdy.ai/api/search-image?query=modern%20renovated%20Korean%20villa%20master%20bathroom%20after%20renovation%20black%20accent%20tiles%20rain%20shower%20glass%20partition%20premium%20fixtures%20elegant%20dark%20sophisticated&width=800&height=600&seq=ba-after-08&orientation=landscape',
    tags: ['레인샤워', '블랙타일', '동시시공'],
  },
];

export default function BeforeAfterGallery() {
  const [activeProcess, setActiveProcess] = useState('전체');
  const [selectedItem, setSelectedItem] = useState<BAItem | null>(null);

  const filtered =
    activeProcess === '전체' ? BA_DATA : BA_DATA.filter((d) => d.process === activeProcess);

  return (
    <section className="bg-[#f7f5f2] py-20">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div>
            <span
              className="inline-block text-xs font-semibold tracking-[0.3em] uppercase mb-3"
              style={{ color: '#c9a84c' }}
            >
              Before &amp; After
            </span>
            <h2
              className="text-3xl md:text-4xl font-light text-[#2a1f14] leading-tight"
              style={{ fontFamily: "'Noto Serif KR', serif" }}
            >
              공정별 시공 전후 비교
            </h2>
            <p className="text-[#8b7355] text-sm mt-2 leading-relaxed">
              슬라이더를 드래그하여 시공 전후를 직접 비교해 보세요.
            </p>
          </div>
          {/* Process Filter */}
          <div className="flex flex-wrap gap-2">
            {PROCESS_TABS.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveProcess(tab)}
                className="px-4 py-2 rounded-full text-sm font-medium cursor-pointer transition-all whitespace-nowrap"
                style={
                  activeProcess === tab
                    ? { backgroundColor: '#c9a84c', color: '#fff' }
                    : {
                        border: '1px solid #d4c5a9',
                        color: '#6b5e4e',
                        backgroundColor: 'transparent',
                      }
                }
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {filtered.map((item) => (
            <div
              key={item.id}
              className="group rounded-2xl overflow-hidden cursor-pointer"
              style={{ backgroundColor: '#fff', border: '1px solid #e8ddd0' }}
              onClick={() => setSelectedItem(item)}
            >
              {/* Slider Area */}
              <div className="relative w-full h-64 md:h-72">
                <BeforeAfterSlider
                  beforeImg={item.beforeImg}
                  afterImg={item.afterImg}
                />
                {/* Process Badge */}
                <div className="absolute bottom-3 left-3 pointer-events-none">
                  <span
                    className="text-xs font-bold px-2.5 py-1 rounded-full"
                    style={{ backgroundColor: '#c9a84c', color: '#0d0d0d' }}
                  >
                    {item.process}
                  </span>
                </div>
                {/* Expand hint */}
                <div
                  className="absolute bottom-3 right-3 w-8 h-8 flex items-center justify-center rounded-full pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity"
                  style={{ backgroundColor: '#0d0d0dcc' }}
                >
                  <i className="ri-fullscreen-line text-white text-sm" />
                </div>
              </div>

              {/* Info */}
              <div className="p-5">
                <div className="flex items-start justify-between gap-3 mb-2">
                  <h3 className="text-[#2a1f14] font-semibold text-base leading-snug flex-1">
                    {item.title}
                  </h3>
                  <span className="text-[#8b7355] text-xs shrink-0 mt-0.5">{item.date}</span>
                </div>
                <div className="flex items-center gap-3 mb-3">
                  <span className="flex items-center gap-1 text-xs text-[#8b7355]">
                    <i className="ri-map-pin-line" />
                    {item.location}
                  </span>
                  <span className="text-[#d4c5a9]">·</span>
                  <span className="text-xs text-[#8b7355]">{item.size}</span>
                </div>
                <p className="text-[#6b5e4e] text-sm leading-relaxed mb-4 line-clamp-2">
                  {item.description}
                </p>
                <div className="flex flex-wrap gap-1.5">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="text-xs px-2.5 py-1 rounded-full"
                      style={{
                        backgroundColor: '#c9a84c15',
                        color: '#8b6914',
                        border: '1px solid #c9a84c30',
                      }}
                    >
                      #{tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {filtered.length === 0 && (
          <div className="text-center py-20 text-[#9e8e7e] text-sm">
            해당 공정의 Before/After 사례가 없습니다.
          </div>
        )}
      </div>

      {/* Modal */}
      {selectedItem && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-8"
          style={{ backgroundColor: 'rgba(0,0,0,0.85)' }}
          onClick={() => setSelectedItem(null)}
        >
          <div
            className="relative w-full max-w-4xl rounded-2xl overflow-hidden"
            style={{ backgroundColor: '#1a1a1a' }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close */}
            <button
              onClick={() => setSelectedItem(null)}
              className="absolute top-4 right-4 z-10 w-9 h-9 flex items-center justify-center rounded-full cursor-pointer transition-colors"
              style={{ backgroundColor: '#ffffff20', color: '#fff' }}
            >
              <i className="ri-close-line text-lg" />
            </button>

            {/* Slider Large */}
            <div className="w-full h-72 md:h-[420px]">
              <BeforeAfterSlider
                beforeImg={selectedItem.beforeImg}
                afterImg={selectedItem.afterImg}
              />
            </div>

            {/* Detail Info */}
            <div className="p-6 md:p-8">
              <div className="flex flex-wrap items-center gap-3 mb-3">
                <span
                  className="text-xs font-bold px-3 py-1 rounded-full"
                  style={{ backgroundColor: '#c9a84c', color: '#0d0d0d' }}
                >
                  {selectedItem.process}
                </span>
                <span className="text-white/50 text-xs">{selectedItem.location}</span>
                <span className="text-white/30">·</span>
                <span className="text-white/50 text-xs">{selectedItem.size}</span>
                <span className="text-white/30">·</span>
                <span className="text-white/50 text-xs">{selectedItem.date}</span>
              </div>
              <h3 className="text-white font-bold text-xl mb-3">{selectedItem.title}</h3>
              <p className="text-white/60 text-sm leading-relaxed mb-5">{selectedItem.description}</p>
              <div className="flex flex-wrap gap-2 mb-6">
                {selectedItem.tags.map((tag) => (
                  <span
                    key={tag}
                    className="text-xs px-3 py-1.5 rounded-full"
                    style={{
                      backgroundColor: '#c9a84c20',
                      color: '#c9a84c',
                      border: '1px solid #c9a84c40',
                    }}
                  >
                    #{tag}
                  </span>
                ))}
              </div>
              <div className="flex gap-3">
                <a
                  href="/estimate"
                  className="flex-1 text-center py-3 rounded-full text-sm font-bold cursor-pointer transition-colors whitespace-nowrap"
                  style={{ backgroundColor: '#c9a84c', color: '#0d0d0d' }}
                >
                  이 스타일로 견적 받기
                </a>
                <a
                  href="/consultation"
                  className="flex-1 text-center py-3 rounded-full text-sm font-bold cursor-pointer transition-colors whitespace-nowrap"
                  style={{
                    backgroundColor: 'transparent',
                    color: '#c9a84c',
                    border: '1px solid #c9a84c55',
                  }}
                >
                  무료 상담 신청
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
